import { render } from "./insure-daily-ax.vue?vue&type=template&id=da788600&scoped=true&ts=true"
import script from "./insure-daily-ax.vue?vue&type=script&lang=ts"
export * from "./insure-daily-ax.vue?vue&type=script&lang=ts"

import "./insure-daily-ax.vue?vue&type=style&index=0&id=da788600&scoped=true&lang=stylus"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da788600"]])

export default __exports__